export default "__VITE_ASSET__118d7872__"